import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import de from './locales/de.json';
import en from './locales/en.json';
import cs from './locales/cs.json';
import ro from './locales/ro.json';

const resources = {
  de: { translation: de },
  en: { translation: en },
  cs: { translation: cs },
  ro: { translation: ro },
};

// Get language from localStorage, fallback to 'en'
const savedLanguage = localStorage.getItem('language') || 'en';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true
    }
  });

export default i18n;
